import { motion } from "framer-motion";

// Gentle scroll-in reveal — intentionally subtle (Modern Craft direction).
export const Reveal = ({ children, delay = 0, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 22 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.65, delay, ease: [0.33, 1, 0.68, 1] }}
  >
    {children}
  </motion.div>
);
